<template>
  <div :class="{'has-visible-selectors': selectors}" class="c grid-areas">
    <div class="activator">
      <v-btn
        color="primary"
        round
        large
        :icon="selectors"
        @click="toggleSelectors"
      >
        <span v-show="!selectors">Netzgebiet wählen</span>
        <v-icon v-show="selectors">close</v-icon>
      </v-btn>
    </div>
    <div class="selectors">
      <v-layout row wrap>
        <v-flex
          v-for="area in gridAreas"
          :key="area.id"
          xs12
          sm3
          md2
          @mouseover="onMouseover(area)"
          @click="onClick(area)"
        >
          <v-card :class="{'is-selected': shownArea === area.id}" :hover="shownArea !== area.id">
            <v-card-text class="title">
              {{ area.label }}
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GridAreas',

  data() {
    return {
      selectors: false,
    };
  },

  computed: {
    interval() {
      return this.$store.state.gridAreas.changeInterval;
    },
    gridAreas() {
      return this.$store.state.gridAreas.areas;
    },
    shownArea() {
      return this.$store.state.gridAreas.shownArea;
    },
  },

  methods: {
    toggleSelectors() {
      this.selectors = !this.selectors;
    },
    onMouseover(area) {
      if (this.shownArea !== area.id) {
        this.$emit('item-hover', area);
      }
    },
    onClick(area) {
      this.$emit('item-click', area);
      this.toggleSelectors();
    },
  },
};
</script>
